import Success from './Success.component';

export default Success;
